export default __webpack_public_path__ + "static/media/stakelogic.2645ae88.png";